import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";

export default function LibraryDashboard() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/archives/search").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="library-dashboard">
      <div className="eyebrow eyebrow-dark">Bibliothèque</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Documents publiés</h1>
      <p className="mt-2 text-slate-600 text-sm">Mémoires et travaux validés diffusés dans le Dépôt institutionnel.</p>
      <span className="divider-gold mt-3" />

      <div className="mt-8 paper-card overflow-hidden">
        <table className="unisic-table w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3">Titre</th>
              <th className="px-4 py-3">Auteur</th>
              <th className="px-4 py-3">Discipline</th>
              <th className="px-4 py-3">Année</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((d) => (
              <tr key={d.deposit_id} className="hover:bg-slate-50">
                <td className="px-4 py-3 max-w-md truncate">{d.title}</td>
                <td className="px-4 py-3">{d.author_name}</td>
                <td className="px-4 py-3">{d.discipline}</td>
                <td className="px-4 py-3">{d.academic_year}</td>
                <td className="px-4 py-3 text-right">
                  {d.file_path && (
                    <a href={fileUrl(d.file_path)} target="_blank" rel="noopener noreferrer" className="link-underline text-xs">
                      Consulter
                    </a>
                  )}
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={5} className="text-center py-10 text-slate-500">Aucun document publié.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
